import theme from '@nextretreat/ui-components/dist/Theme'
import { Text, H1 } from 'components'

export const ThankYouMessage = () => {
  return (
    <>
      <H1>Thank you for listing your venue with us</H1>

      <Text lineHeight={theme.lineHeights.m} as="p" textAlign="center">
        Our team will get to you soon after reviewing your venue. Until then you
        can visit us at{' '}
        <a href="https://www.nextretreat.com/">NextRetreat.com</a>
      </Text>
    </>
  )
}
